import React from "react";
import { IconSize, IconProps } from "../theme";

const Picture: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V27C7 27.7956 7.31607 28.5587 7.87868 29.1213C8.44129 29.6839 9.20435 30 10 30H22C22.7956 30 23.5587 29.6839 24.1213 29.1213C24.6839 28.5587 25 27.7956 25 27V5C25 4.20435 24.6839 3.44129 24.1213 2.87868C23.5587 2.31607 22.7956 2 22 2ZM16 9C15.7033 9 15.4133 8.91203 15.1666 8.7472C14.92 8.58238 14.7277 8.34811 14.6142 8.07403C14.5006 7.79994 14.4709 7.49834 14.5288 7.20736C14.5867 6.91639 14.7296 6.64912 14.9393 6.43934C15.1491 6.22956 15.4164 6.0867 15.7074 6.02882C15.9983 5.97094 16.2999 6.00065 16.574 6.11418C16.8481 6.22771 17.0824 6.41997 17.2472 6.66664C17.412 6.91332 17.5 7.20333 17.5 7.5C17.5 7.89782 17.342 8.27936 17.0607 8.56066C16.7794 8.84196 16.3978 9 16 9Z"
        fill="#071443"
      />
    </svg>
  );
};

export default Picture;
